import editModalTpl from './templates/edit.modal.html';

import BlndTable from 'app/common/table';

const AVAILABLE_PRINTER_STATUSES = ['online', 'offline', 'unknown', 'dormant'];


export class PrinterListCtrl {
    constructor (NgTableParams, $sce, $growl, $location, PrinterStore, Modal) {
        "ngInject";
        let self = this;
        self.Modal = Modal;
        self.$growl = $growl;
        self.$location = $location;
        self.connected = true;
        self.store = PrinterStore;
        self.store.init();

        self.params = {
            status: AVAILABLE_PRINTER_STATUSES,
        };

        this.table = new BlndTable(NgTableParams, this.store, {
            defaultParams: {
                status: AVAILABLE_PRINTER_STATUSES,
            },
            params: self.params,
        });

        this.store.$promise.then(() => {}, () => self.connected = false);
    }

    getRedirect() {
        if (baseConfig.backendUrl === '') {
            return '/admin/printers';
        }
        return `${this.$location.protocol()}://${this.$location.host()}:8080/admin/printers`;
    }

    refreshConfirmationModal () {
        let self = this;
        let $modal = self.Modal.openConfirm({
            confirmName: 'Yes',
            text: `Are you sure you want to refresh all printers?`,
        });
        $modal.wait.then(function() {
            self.loading = true;
            $modal.close();
            self.store.create()
                .then(
                    () => {
                        self.$growl.success('Printers have been updated');
                    },
                (response) => {
                    if (response.status === 403) {
                        self.connected = false;
                        self.$growl.error('Could not refresh printers.')
                    }
                }
            )
            .finally(() => {
                self.table.refresh(self.params);
                self.loading = false;
            });
        });
    }

    editModal (id) {
        let self = this;
        let $modal = this.Modal.open({
            template: editModalTpl,
            controller: EditPrinterCtrl,
            size: 'sm',
            resolve: {
                object: () => self.store.get(id),
            },
        });

        $modal.result.then(function(){
            self.$growl.updated();
            self.table.refresh(self.params);
        });
    }
}


class EditPrinterCtrl {

    constructor (R, $uibModalInstance, object) {
        "ngInject";

        this.$modal = $uibModalInstance;
        this.object = object;
        this.R = R;
        this.data = this.R.copy(this.object);
    }

    get title () {
        return `Edit ${this.data.display_name}`;
    }

    close () {
        this.$modal.dismiss();
    }

    submit () {
        let self = this;
        this.data.put().then(
            function(data){
                angular.extend(self.object, data);
                self.$modal.close();
            },
            function(resp) {
                self.errors = resp.data;
            },
        ).finally(() => self.loading = false);
    }
}



// WEBPACK FOOTER //
// ./src/app/admin/printers/ctrls.js